export class InvoiceReplaceVM {
  invoiceId: number = null;
  newFormTplId: number = null;
}
